export class LoginWithTokenAction {
  static type = '[AUTH] Login with Token';

  constructor(
    readonly token: string,
    readonly userType: 'CLIENT' | 'PARTNER' = 'CLIENT'
  ) {}
}
